import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { subDays } from "date-fns";
import { BankReconciliationFilters } from "src/pages/Payments/BankReconciliation/BankReconciliation";
import { fDate } from "src/utils/formatTime";

type DefaultQuery = {
  documentList: {
    query: string;
    enable: boolean;
  };
  bankReconciliation: {
    query: BankReconciliationFilters;
    enable: boolean;
  };
};

const initialState: DefaultQuery = {
  documentList: {
    query: "",
    enable: false,
  },
  bankReconciliation: {
    query: {
      startDate: fDate(subDays(new Date(), 29), "yyyy-MM-dd"),
      endDate: fDate(new Date(), "yyyy-MM-dd"),
      organizationPaymentGatewayId: "",
      orgPaymentGatewayAccountDetailId: "",
      reconciliationStatus: "-1",
      currencyFormat: "",
    },
    enable: false,
  },
};

const slice = createSlice({
  name: "Query",
  initialState,
  reducers: {
    setDocumentListQueryAction(state, action: PayloadAction<string>) {
      state.documentList.query = action.payload;
    },
    toggleDocumentListQueryAction(state, action: PayloadAction<boolean>) {
      state.documentList.enable = action.payload;
      if (!action.payload) {
        state.documentList.query = "";
      }
    },
    setBankReconciliationQueryAction(
      state,
      action: PayloadAction<BankReconciliationFilters>,
    ) {
      state.bankReconciliation.query = action.payload;
    },
    toggleBankReconciliationQueryAction(state, action: PayloadAction<boolean>) {
      state.bankReconciliation.enable = action.payload;
      if (!action.payload) {
        state.bankReconciliation.query = {
          startDate: "",
          endDate: "",
          organizationPaymentGatewayId: "",
          orgPaymentGatewayAccountDetailId: "",
          reconciliationStatus: "",
          currencyFormat: "",
        };
      }
    },
  },
});

// Reducer
export default slice.reducer;

export const {
  setDocumentListQueryAction,
  toggleDocumentListQueryAction,
  setBankReconciliationQueryAction,
  toggleBankReconciliationQueryAction,
} = slice.actions;

export function setDocumentListQuery(query: string) {
  return (dispatch) => {
    dispatch(setDocumentListQueryAction(query));
  };
}

export function toggleDocumentListQuery(enable: boolean) {
  return (dispatch) => {
    dispatch(toggleDocumentListQueryAction(enable));
  };
}

export function setBankReconciliationQuery(query: BankReconciliationFilters) {
  return (dispatch) => {
    dispatch(setBankReconciliationQueryAction(query));
  };
}

export function toggleBankReconciliationQuery(enable: boolean) {
  return (dispatch) => {
    dispatch(toggleBankReconciliationQueryAction(enable));
  };
}

export function setDocListRowsPerPage(rowsPerPage: number) {
  return (dispatch) => {
    dispatch(setDocumentListQueryAction(`rowsPerPage=${rowsPerPage}`));
  };
}
